// extracted by mini-css-extract-plugin
export var camp = "camp-seasonal-module--camp--531fe";
export var campBody = "camp-seasonal-module--campBody--5c99f";
export var campFooter = "camp-seasonal-module--campFooter--46cb0";
export var campIcons = "camp-seasonal-module--campIcons--5f85b";
export var campPricingBlock = "camp-seasonal-module--campPricingBlock--6217b";